export const seasonalAnnotations = [
  {
    label: 'Fall',
    start: '2024-09-21',
    end: '2024-12-20',
    color: 'rgba(255, 165, 0, 0.1)',
  },
  {
    label: 'Winter',
    start: '2024-12-21',
    end: '2025-03-20',
    color: 'rgba(173, 216, 230, 0.15)',
  },
  {
    label: 'Spring',
    start: '2025-03-21',
    end: '2025-06-20',
    color: 'rgba(144, 238, 144, 0.15)',
  },
  {
    label: 'Summer',
    start: '2025-06-21',
    end: '2025-09-20',
    color: 'rgba(255, 255, 0, 0.15)',
  },
  {
    label: 'Fall',
    start: '2025-09-21',
    end: '2025-11-18',
    color: 'rgba(255, 165, 0, 0.1)',
  },
];

export const annotations = seasonalAnnotations.reduce((acc, season, index) => {
  acc[`season-${index}`] = {
    type: 'box',
    xMin: season.start,
    xMax: season.end,
    backgroundColor: season.color,
    borderWidth: 0,
  };
  return acc;
}, {} as any);

export const legendData = seasonalAnnotations.map((season, index) => ({
  label: season.label,
  backgroundColor: season.color,
}));
